<template>
<div class="swaychat-message-box">
  <div class="swaychat-message-wrapper" :style="{
    'box-shadow': focused ? '0 0 0 2px rgba(0,0,0,0.05)' : ''
    }">
    <form novalidate @submit.prevent="post">
      <!--Reply-->
      <div class="swaychat-reply">
        <textarea id="swaychat-message-text"
          ref="message"
          v-model="message"
          @input="adjust_text_height($event.target.value)"
          @input="recordTyping($event.target.value)"
          @focus="focused = true"
          @blur="focused = false"
          @keypress="keypress($event)"
          :class="{
            'swaychat-textarea-expanded': expanded
          }"
          :placeholder="getLang.reply_message">
        </textarea>
      </div>
      <div class="swaychat-icon-more" @click="showMore = !showMore"></div>
      <div class="swaychat-send-button">
        <button-form-component type="submit" expand="true" primary="true" :label="getLang.send"></button-form-component>
      </div>
    </form>

    <!--Reply End-->
  </div>
  <more-menu v-show="showMore" @hide="showMore = false"></more-menu>
  <powered-by-component></powered-by-component>
  <!--Dropdown Component Here-->
</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import firebaseApp from '../utils/firebase'

import ButtonFormComponent from './input/ButtonFormComponent.vue'
import PoweredByComponent from './PoweredByComponent.vue'
import MoreMenu from './MoreMenu.vue'

export default {
  components: {
    ButtonFormComponent,
    PoweredByComponent,
    MoreMenu
  },
  created() {
    this.initTypeRecorder()
  },
  destroyed() {

    if (this.typingRef) {
      this.typingRef.remove()
      this.typingRef.onDisconnect().cancel()
    }

  },
  data() {
    return {
      showMore: false,
      expanded: false,
      focused: false,
      message: '',
      typingRef: null,

    }
  },
  computed: {
    ...mapGetters([
      'getLang',
      'bindSID'
    ])
  },
  watch: {
    bindSID() {
      this.initTypeRecorder()
    }
  },
  methods: {
    post() {

      let message = this.message.trim()

      if (message) {
        this.$store.dispatch('postMessage', message)
        this.message = ''
        this.expanded = false
        this.recordTyping('')
      }

    },
    keypress(e) {
      if (e.keyCode == 13) {
        e.preventDefault()
        this.post()
      }
    },
    initTypeRecorder() {

      if (this.bindSID && !this.typingRef) {

        this.typingRef = firebaseApp.ref
          .child('messages')
          .child(this.bindSID)
          .child('actions')
          .child('isVisitorTyping')

        this.typingRef.onDisconnect()
          .remove()

      }

    },
    recordTyping(v) {
      if (this.typingRef)
        this.typingRef.set(v)
    },
    adjust_text_height(v) {
      this.expanded = (v.length > 24)
    }
  }
}
</script>
